import { useQuery } from '@tanstack/react-query';

import { PricingPlanTickRate } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-tick-rate/:tickRateId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    planId: string;
    tickRateId: string;
    parkingId: string;
}
const queryFn = ({ planId, tickRateId, parkingId}: DTO): Promise<PricingPlanTickRate> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, tickRateId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPricingPlanTickRate };
